import { Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';

export const routes: Routes = [
    {
        path:'login',
        loadComponent: () => import("./pages/login/login.component")
            .then(x => x.LoginComponent)
    },
    {
        path:'forgot-password',
        loadComponent: () => import("./pages/auth/forgot-password/forgot-password.component")
            .then(x => x.ForgotPasswordComponent)
    },
    {
        path:'',
        loadChildren: () => import("./pages/site/site.routing")
            .then(m => m.SiteRoutes), canActivate: [AuthGuard], canActivateChild: [AuthGuard]
    },
    {
        path: '**',
        loadChildren: () => import("./pages/site/site.routing")
            .then(m => m.SiteRoutes), canActivate: [AuthGuard], canActivateChild: [AuthGuard]
    }
];
